import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ChevronUpIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path d='M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z' fill='currentColor'/>
    </svg>
));
